import { gql } from '@apollo/client'

export const GET_BLOG_POST_BY_URL = gql`
    query GetBlogPostByUrlKey($urlKey: String!) {
        mpBlogPosts(action: "get_post_list"filter: { url_key: { eq: $urlKey }}) {
            total_count
            items {
                post_id
                name
                short_description
                post_content
                store_ids
                image
                enabled
                url_key
                author_url
                author_url_key
                author_name
                view_traffic
                in_rss
                allow_comment
                meta_title
                meta_keywords
                meta_description
                meta_robots
                created_at
                updated_at
                author_id
                publish_date
                import_source
                layout
                categories {
                    items {
                        category_id
                        name
                    }
                }
                tags {
                    items {
                        tag_id
                        name
                    }
                }
                topics {
                    items {
                        topic_id
                        name
                    }
                }
                products {
                    items {
                        entity_id
                        sku
                        url_key
                    }
                }
                posts {
                    items {
                        post_id
                        name
                    }
                }
            }
        }
    }
`
